export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10888.7a41b498.jpg";